import type { Translations } from '../types.js';

export const uz: Translations = {
  nav: {
    overview: 'Boshqaruv paneli',
    users: 'Foydalanuvchilar',
    devices: 'Qurilmalar',
    subscriptions: 'Obunalar',
    entitlements: 'Huquqlar',
    features: 'Funksiyalar',
    config: 'Sozlamalar',
    commands: 'Buyruqlar',
    snapshots: 'Diagnostika',
    audit: 'Audit',
    system: 'Tizim holati',
    consoleTag: 'Konsol v1.0',
    signOut: 'Chiqish',
    expandSidebar: 'Menyuni kengaytirish',
    collapseSidebar: 'Menyuni yig\'ish',
  },
  topbar: {
    admin: 'Admin',
    searchPlaceholder: 'Foydalanuvchilar, qurilmalar, buyruqlarni qidirish...',
    searchShortcut: '⌘K',
    lightMode: 'Yorug\' rejim',
    darkMode: 'Qorong\'i rejim',
    systemTheme: 'Tizim rejimi',
    notifications: 'Bildirishnomalar',
    profile: 'Profil',
    language: 'Til',
  },
  login: {
    title: 'Hisob Boshqaruv Konsoli',
    subtitle: 'Maxfiylikka asoslangan ma\'muriyat va mobil qurilmalar nazorati',
    emailLabel: 'Admin elektron pochtasi',
    emailPlaceholder: 'masalan, admin@hisob.uz',
    secretLabel: 'Kirish maxfiy kaliti',
    secretPlaceholder: '••••••••••••••••',
    submitButton: 'Konsolga kirish',
    signingIn: 'Kirilmoqda...',
    errorRequired: 'Iltimos, admin pochtasi va maxfiy kalitni kiriting',
    errorInvalid: 'Noto\'g\'ri admin ma\'lumotlari',
    devSwitcherTitle: 'Tezkor rolni tanlash (Ishlab chiqish)',
  },
  common: {
    search: 'Qidirish',
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: 'O\'chirish',
    restore: 'Qaytarish',
    filter: 'Filtrlash',
    refresh: 'Yangilash',
    confirm: 'Tasdiqlash',
    close: 'Yopish',
    loading: 'Yuklanmoqda...',
    actions: 'Amallar',
    status: 'Holat',
    success: 'Muvaffaqiyatli',
    error: 'Xatolik',
    view: 'Ko\'rish',
    edit: 'Tahrirlash',
    all: 'Barchasi',
    active: 'Faol',
    inactive: 'Nofaol',
    pending: 'Kutilmoqda',
    failed: 'Muvaffaqiyatsiz',
    revoked: 'Bekor qilingan',
    copied: 'Nusxalandi',
    copy: 'Nusxa olish',
    back: 'Orqaga',
    authenticating: 'Admin sessiyasi tekshirilmoqda...',
    yes: 'Ha',
    no: 'Yo\'q',
    resetFilters: 'Filtrlarni tozalash',
    firstPage: 'Birinchi sahifa',
    nextPage: 'Keyingi sahifa',
    details: 'Batafsil',
    viewAll: 'Barchasini ko\'rish',
  },
  statusPages: {
    notFoundTitle: '404 — Sahifa topilmadi',
    notFoundDesc: 'Siz qidirayotgan konsol marshruti yoki ma\'muriy resurs mavjud emas yoki boshqa joyga ko\'chirilgan.',
    returnToDashboard: 'Boshqaruv paneliga qaytish',
    forbiddenTitle: '403 — Ruxsat berilmagan harakat',
    forbiddenDesc: 'Sizning joriy admin rolingiz ushbu resursni ko\'rish yoki o\'zgartirish uchun yetarli RBAC huquqlariga ega emas.',
    returnToSafety: 'Xavfsiz joyga qaytish',
  },
  searchModal: {
    title: 'Umumiy operatsion qidiruv',
    placeholder: 'Foydalanuvchi ID, Qurilma ID, Buyruq ID, Versiya bo\'yicha qidiring...',
    noResults: 'Qidiruv bo\'yicha mos yozuvlar topilmadi: ',
    typeMinChars: 'Foydalanuvchilar, qurilmalar, buyruqlar va boshqalarni qidirish uchun kamida 2 ta belgi kiriting.',
    pressEsc: 'Yopish uchun ESC tugmasini bosing',
    tip: 'Maslahat: Resurslarga to\'g\'ridan-to\'g\'ri o\'tishingiz mumkin',
    users: 'Foydalanuvchilar',
    devices: 'Qurilmalar',
    commands: 'Buyruqlar',
    snapshots: 'Diagnostika nusxalari',
    subscriptions: 'Obunalar',
  },
  dashboard: {
    title: 'Boshqaruv paneli',
    totalUsers: 'Jami foydalanuvchilar',
    activeDevices: 'Faol qurilmalar',
    onlineDevices: 'Onlayn qurilmalar',
    premiumUsers: 'Premium foydalanuvchilar',
    subscriptions: 'Obunalar',
    pendingCommands: 'Kutilayotgan buyruqlar',
    activeSnapshots: 'Faol diagnostikalar',
    featureFlagsOn: 'Yoqilgan funksiyalar',
    systemHealth: 'Tizim holati',
    recentActivity: 'So\'nggi harakatlar',
    failedToLoad: 'Boshqaruv paneli ko\'rsatkichlarini yuklab bo\'lmadi',
    bannerTitle: 'Tizimning operatsion holati',
    bannerDesc: 'Cloudflare edge trafigi normal yo\'naltirilmoqda. Qurilmalar telemetriyasi jonli uzatilmoqda.',
    dispatchCommand: 'Buyruq yuborish',
    inspectFleet: 'Qurilmalarni ko\'rish',
    infraHealthTitle: 'Cloudflare Edge infratuzilmasi holati',
    checkedAgo: 'Tekshirildi: {time}',
    chartActiveDevices: 'Kunlik faol qurilmalar (7 kun)',
    chartPlatforms: 'Platformalar taqsimoti',
    recentFleetCommands: 'So\'nggi qurilma buyruqlari',
    recentAuditEvents: 'So\'nggi admin audit hodisalari',
    deviceLabel: 'Qurilma',
    targetLabel: 'Obyekt',
  },
  users: {
    title: 'Foydalanuvchilar boshqaruvi',
    description: 'Foydalanuvchi hisoblari, Telegram orqali bog\'langanlik holati va so\'nggi kirish/tasdiqlash monitoringi',
    searchPlaceholder: 'User ID, Telefon raqam yoki Chat ID...',
    allTelegram: 'Barcha Telegram holatlari',
    linkedOnly: 'Faqat bog\'langanlar',
    unlinkedOnly: 'Bog\'lanmaganlar',
    allStatuses: 'Barcha statuslar',
    activeStatus: 'Faol',
    suspendedStatus: 'To\'xtatilgan',
    deletedStatus: 'O\'chirilgan',
    tableUserId: 'Foydalanuvchi ID',
    tablePhone: 'Telefon raqami',
    tableTelegram: 'Telegram holati',
    tableLastLogin: 'So\'nggi kirish / Tasdiqlash',
    tableStatus: 'Holati',
    tableRegistered: 'Ro\'yxatdan o\'tgan',
    tableActions: 'Amallar',
    noPhone: 'Mavjud emas',
    noLoginRecorded: 'Kirish qayd etilmagan',
    emptyTitle: 'Foydalanuvchilar topilmadi',
    emptyDesc: 'Qidiruv yoki filtr shartlariga mos keladigan foydalanuvchi hisoblari mavjud emas.',
    totalCount: 'Jami: {count} ta foydalanuvchi',
    loadError: 'Foydalanuvchilarni yuklab bo\'lmadi',
  },
  userDetail: {
    backButton: 'Foydalanuvchilarga qaytish',
    title: 'Foydalanuvchi profili ma\'lumotlari',
    privacyNoticeTitle: 'Maxfiylik arxitekturasi eslatmasi:',
    privacyNoticeDesc: 'Hisob tizimi xavfsizlik arxitekturasiga muvofiq, moliyaviy ma\'lumotlar (balanslar, tranzaksiyalar, kartalar) hech qachon serverda saqlanmaydi va faqat foydalanuvchi qurilmasida mahalliy saqlanadi. Ushbu admin profil faqat qurilma kalitlari, obuna huquqlari va diagnostika so\'rovlarini boshqaradi.',
    accountOverview: 'Hisob ma\'lumotlari',
    phoneNumber: 'Telefon raqami',
    telegramChatId: 'Telegram Chat ID',
    registeredAt: 'Ro\'yxatdan o\'tgan sana',
    lastActive: 'So\'nggi faollik',
    accountStatus: 'Hisob holati',
    registeredDevices: 'Biriktirilgan qurilmalar',
    noDevices: 'Ushbu foydalanuvchiga biriktirilgan qurilmalar topilmadi.',
    entitlementsTitle: 'Foydalanuvchi huquqlari',
    noEntitlements: 'Faol obuna yoki maxsus huquqlar mavjud emas.',
    notFoundTitle: 'Foydalanuvchi topilmadi',
  },
  devices: {
    title: 'Mobil qurilmalar parki',
    description: 'Ro\'yxatdan o\'tgan iOS va Android mijoz ilovalari, xavfsizlik tokeni holati va telemetriya',
    searchPlaceholder: 'Qurilma ID, Foydalanuvchi ID, Model bo\'yicha qidiring...',
    allPlatforms: 'Barcha platformalar',
    tableDeviceId: 'Qurilma ID',
    tableUserId: 'Foydalanuvchi ID',
    tableModelPlatform: 'Model va Platforma',
    tableAppVersion: 'Ilova versiyasi',
    tableStatus: 'Holati',
    tableLastSeen: 'So\'nggi faollik',
    tableActions: 'Amallar',
    online: 'Onlayn',
    offline: 'Oflayn',
    revoked: 'Bekor qilingan',
    revokeButton: 'Chiqarish',
    revokeModalTitle: 'Qurilma ruxsatini bekor qilish',
    revokeModalMessage: 'Haqiqatan ham "{id}" qurilmasining kirish huquqini bekor qilmoqchimisiz? Barcha faol JWT tokenlari darhol rad etiladi va qurilma backenddan uziladi.',
    revokeConfirmText: 'Doimiy bekor qilish',
    revokeSuccessToast: 'Qurilma muvaffaqiyatli bekor qilindi',
    emptyTitle: 'Qurilmalar topilmadi',
    emptyDesc: 'Tanlangan mezonlarga mos qurilmalar mavjud emas.',
    totalCount: 'Jami {count} ta qurilma ko\'rsatilmoqda',
    loadError: 'Qurilmalarni yuklab bo\'lmadi',
  },
  deviceDetail: {
    backButton: 'Qurilmalarga qaytish',
    title: 'Qurilma tafsilotlari',
    hardwareSpecs: 'Texnik va apparat xususiyatlari',
    model: 'Model',
    platform: 'Platforma',
    osVersion: 'OT versiyasi',
    appVersion: 'Ilova versiyasi',
    registeredAt: 'Ro\'yxatdan o\'tgan sana',
    lastSeen: 'So\'nggi aloqa',
    securityStatus: 'Xavfsizlik va token holati',
    deviceTokenStatus: 'Qurilma tokeni',
    userId: 'Biriktirilgan foydalanuvchi ID',
    quickCommands: 'Tezkor qurilma buyruqlari',
    dispatchCommandBtn: 'Yangi buyruq yuborish',
    commandsHistory: 'Buyruqlar tarixi',
    noCommands: 'Ushbu qurilma uchun buyruqlar mavjud emas.',
    modalTitle: 'Qurilma uchun buyruq yaratish',
    commandTypeLabel: 'Buyruq turi',
    commandReasonLabel: 'Sababi / Maqsadi',
    commandReasonPlaceholder: 'masalan, foydalanuvchi muammosini tekshirish uchun',
    commandTtlLabel: 'Amal qilish muddati (soat)',
    submitCommand: 'Buyruqni navbatga qo\'yish',
    revokeConfirmTitle: 'Qurilmani butunlay o\'chirish',
  },
  subscriptions: {
    title: 'Magazin obunalari reestri',
    description: 'App Store, Google Play va RevenueCat orqali xarid qilingan va tekshirilgan obunalar',
    searchPlaceholder: 'Foydalanuvchi, Tashqi ID yoki Mahsulot bo\'yicha qidiring...',
    tableId: 'ID',
    tableUserId: 'Foydalanuvchi ID',
    tableStore: 'Magazin',
    tableProduct: 'Mahsulot ID',
    tableStatus: 'Holati',
    tableExpiresAt: 'Tugash sanasi',
    tableCreatedAt: 'Yaratilgan sana',
    emptyTitle: 'Obunalar topilmadi',
    emptyDesc: 'Qidiruv shartlariga mos keladigan obunalar topilmadi.',
    loadError: 'Obunalarni yuklab bo\'lmadi',
  },
  entitlements: {
    title: 'Tasdiqlangan foydalanuvchi huquqlari',
    description: 'Xarid qilingan cheklar yoki admin tomonidan berilgan tasdiqlangan funksional imtiyozlar',
    searchPlaceholder: 'User ID yoki Huquq kaliti bo\'yicha qidiring...',
    tableUserId: 'Foydalanuvchi ID',
    tableEntitlement: 'Huquq kaliti',
    tableStatus: 'Holati',
    tableGrantedBy: 'Beruvchi manba',
    tableExpiresAt: 'Tugash sanasi',
    emptyTitle: 'Huquqlar topilmadi',
    emptyDesc: 'Birorta ham tasdiqlangan foydalanuvchi huquqi topilmadi.',
    loadError: 'Huquqlarni yuklab bo\'lmadi',
  },
  features: {
    title: 'Xususiyatlar bayroqlari (Feature Flags)',
    description: 'Mobil ilovalarga yangi funksiyalarni xavfsiz va bosqichma-bosqich yoqish/o\'chirish',
    searchPlaceholder: 'Bayroq kaliti bo\'yicha qidiring...',
    newFlagBtn: 'Yangi bayroq qo\'shish',
    tableKey: 'Bayroq kaliti',
    tableStatus: 'Holati',
    tableRollout: 'Tarqatish ulushi',
    tableMinVersion: 'Minimal versiya',
    tablePlatform: 'Platforma',
    tablePremiumOnly: 'Faqat Premium',
    tableActions: 'Amallar',
    freeTier: 'Bepul tarif',
    editModalTitle: 'Bayroqni tahrirlash: {key}',
    createModalTitle: 'Yangi xususiyat bayrog\'i yaratish',
    flagKeyLabel: 'Bayroq kaliti (masalan: telegram_otp_auth, new_dashboard)',
    flagKeyPlaceholder: 'masalan: premium.ai_insights',
    enabledLabel: 'Yoqilgan (Enabled)',
    enabledHelp: 'Mos keluvchi barcha qurilmalar segmentida funksiyani bir zumda yoqish yoki o\'chirish.',
    rolloutLabel: 'Tarqatish foizi (%)',
    rolloutHelp: 'Server Device ID asosida doimiy SHA-256 xesh modulo hisoblaydi. Sessiyalar o\'rtasida tasodifiy o\'zgarishlar bo\'lmaydi.',
    platformLabel: 'Platforma',
    platformAll: 'Barcha platformalar',
    platformIos: 'Faqat iOS',
    platformAndroid: 'Faqat Android',
    platformWeb: 'Faqat Web',
    minVersionLabel: 'Minimal ilova versiyasi',
    minVersionPlaceholder: 'masalan, 1.2.0 (ixtiyoriy)',
    premiumOnlyLabel: 'Faqat premium obunachilar uchun',
    premiumOnlyHelp: 'Faqat faol obunaga yoki promo-huquqqa ega bo\'lgan foydalanuvchilar uchun flag = true bo\'ladi.',
    configJsonLabel: 'Qo\'shimcha JSON konfiguratsiya',
    jsonMalformedError: 'Konfiguratsiya JSON formati noto\'g\'ri',
    saveBtn: 'O\'zgarishlarni saqlash',
    createBtn: 'Yaratish',
    saveSuccess: 'Funksiya bayrog\'i muvaffaqiyatli yangilandi',
    createSuccess: 'Funksiya bayrog\'i yaratildi',
    emptyTitle: 'Funksiya bayroqlari topilmadi',
    emptyDesc: 'Tizimda hali birorta ham xususiyat bayrog\'i mavjud emas.',
    loadError: 'Funksiya bayroqlarini yuklab bo\'lmadi',
  },
  config: {
    title: 'Masofaviy ilova sozlamalari (Remote Config)',
    description: 'Mobil ilovaning global parametrlari, majburiy yangilanish talablari va texnik profilaktika',
    minVersionTitle: 'Minimal qo\'llab-quvvatlanadigan versiya',
    minVersionDesc: 'Ushbu versiyadan past mijozlar ilovani yangilashga majbur qilinadi.',
    latestVersionTitle: 'Joriy eng so\'nggi versiya',
    latestVersionDesc: 'Ilova do\'konlarida mavjud eng so\'nggi rasmiy reliz.',
    forceUpdateTitle: 'Majburiy yangilash (Force Update)',
    forceUpdateDesc: 'Yoqilsa, eskirgan versiyadagi foydalanuvchilar yangilamaguncha ilovaga kira olmaydi.',
    maintenanceTitle: 'Texnik profilaktika rejimi',
    maintenanceDesc: 'Favqulodda holatlarda butun mobil API ni texnik tanaffus rejimiga o\'tkazish.',
    maintenanceMessageTitle: 'Foydalanuvchilarga ko\'rsatiladigan xabar',
    storeUrlsTitle: 'Ilova do\'konlari havolalari',
    androidUrl: 'Google Play havolasi',
    iosUrl: 'App Store havolasi',
    changelogTitle: 'O\'zgarishlar matni (Changelog)',
    saveConfigBtn: 'Sozlamalarni saqlash va chekkaga (Edge) yuborish',
    confirmModalTitle: 'Masofaviy sozlamalarni yangilash',
    confirmModalMessage: 'Haqiqatan ham ushbu sozlamalarni yangilamoqchimisiz? O\'zgarishlar bir necha soniya ichida butun dunyo bo\'ylab barcha mobil qurilmalarga ta\'sir qiladi.',
    saveSuccess: 'Ilova sozlamalari muvaffaqiyatli saqlandi va Cloudflare Edge ga tarqatildi.',
    loadError: 'Ilova sozlamalarini yuklab bo\'lmadi',
  },
  commands: {
    title: 'Qurilma buyruqlari boshqaruvi',
    description: 'Qurilmalarga yuborilgan keshni tozalash, diagnostika, sessiyani bekor qilish va h.k. buyruqlar',
    searchPlaceholder: 'Buyruq ID, Qurilma ID yoki Turi bo\'yicha qidiring...',
    allStatuses: 'Barcha holatlar',
    tableId: 'Buyruq ID',
    tableDevice: 'Qurilma ID',
    tableType: 'Turi',
    tableStatus: 'Holati',
    tableCreatedBy: 'Yuboruvchi',
    tableCreatedAt: 'Yaratilgan',
    tableExpiresAt: 'Muddati',
    tableActions: 'Amallar',
    cancelCommandBtn: 'Bekor qilish',
    inspectModalTitle: 'Buyruq tafsilotlari',
    cancelConfirmTitle: 'Buyruqni bekor qilish',
    cancelConfirmMessage: 'Haqiqatan ham ushbu buyruqni bekor qilmoqchimisiz? U qurilmaga yetib bormaydi.',
    cancelSuccess: 'Buyruq bekor qilindi',
    emptyTitle: 'Buyruqlar topilmadi',
    emptyDesc: 'Birorta ham buyruq topilmadi.',
    loadError: 'Buyruqlarni yuklab bo\'lmadi',
  },
  snapshots: {
    title: 'Qo\'llab-quvvatlash va diagnostika nusxalari',
    description: 'Foydalanuvchi roziligi bilan olingan, shifrlangan va vaqtinchalik diagnostika snapshotlari',
    tableId: 'Snapshot ID',
    tableUserId: 'Foydalanuvchi ID',
    tableDeviceId: 'Qurilma ID',
    tableExpiresIn: 'Qolgan muddat',
    tableCreatedAt: 'Olingan sana',
    tableActions: 'Amallar',
    inspectBtn: 'Ochish va Ko\'rish',
    deleteBtn: 'O\'chirish',
    inspectModalTitle: 'Diagnostika nusxasini shifrdan chiqarish',
    inspectPrompt: 'Maxfiylik auditi uchun ushbu diagnostika ma\'lumotlarini ko\'rish sababini kiriting:',
    reasonPlaceholder: 'masalan, foydalanuvchi #4982 chiptasi bo\'yicha kesh xatosini tekshirish',
    submitInspect: 'Shifrdan chiqarish va Ko\'rish',
    deleteModalTitle: 'Diagnostika nusxasini o\'chirish',
    deleteModalMessage: 'Ushbu snapshotni zudlik bilan R2 xotirasidan butunlay yo\'q qilishni tasdiqlaysizmi?',
    deleteSuccess: 'Diagnostika nusxasi muvaffaqiyatli yo\'q qilindi',
    emptyTitle: 'Diagnostika nusxalari mavjud emas',
    emptyDesc: 'Ayni paytda faol diagnostika nusxalari mavjud emas.',
    loadError: 'Diagnostika nusxalarini yuklab bo\'lmadi',
  },
  audit: {
    title: 'Xavfsizlik va audit jurnali',
    description: 'Barcha ma\'muriy va avtorizatsiya amallarining o\'zgarmas auditi (OTP, login, buyruqlar, o\'zgarishlar)',
    tabAuth: 'Avtorizatsiya va OTP amallari',
    tabAll: 'Barcha ma\'muriy harakatlar',
    searchPlaceholder: 'Telefon raqam, Chat ID, Admin ID, Harakat bo\'yicha qidiring...',
    allActions: 'Barcha harakatlar',
    tableTimestamp: 'Vaqt',
    tableActor: 'Ijrochi (Admin/Tizim)',
    tableAction: 'Harakat turi',
    tableTarget: 'Obyekt',
    tableDetails: 'Tafsilotlar',
    emptyTitle: 'Audit yozuvlari topilmadi',
    emptyDesc: 'Ushbu shartlarga mos keladigan audit yozuvlari mavjud emas.',
    inspectModalTitle: 'Audit hodisasi tafsilotlari',
    loadError: 'Audit jurnalini yuklab bo\'lmadi',
  },
  system: {
    title: 'Tizim va chekka infratuzilma holati',
    description: 'Cloudflare global serverless muhiti, D1 ma\'lumotlar bazasi, KV, R2 va navbatlar salomatligi',
    refreshBtn: 'Holatni yangilash',
    allSystemsOperational: 'Barcha tizimlar normal ishlamoqda',
    apiWorker: 'Cloudflare Workers Edge API',
    apiWorkerDesc: '/api/v1/* so\'rovlariga javob beruvchi global V8 muhiti',
    d1Db: 'Cloudflare D1 ma\'lumotlar bazasi',
    d1DbDesc: 'Ko\'p mintaqali replikatsiyalarga ega serverless SQLite klasteri',
    kvConfig: 'Cloudflare KV nomlar fazosi',
    kvConfigDesc: 'Sozlamalar va bayroqlar uchun sub-millisekundlik xotira',
    r2Storage: 'Cloudflare R2 obyekt saqlash xotirasi',
    r2StorageDesc: 'Shifrlangan diagnostika nusxalari uchun S3-mos xotira',
    queues: 'Cloudflare navbatlari (Queues)',
    queuesDesc: 'Telemetriya va audit jurnallari uchun asinxron uzatish',
    cronWorker: 'Avtomatlashtirilgan Cron jarayoni',
    cronWorkerDesc: 'Muddati o\'tgan snapshotlarni tozalash har soatda ishga tushadi',
    latency: 'Kechikish: {val}',
    loadError: 'Tizim salomatligini tekshirib bo\'lmadi',
  },
  commandTypes: {
    export_snapshot: 'Diagnostika nusxasini olish',
    clear_cache: 'Mahalliy keshni tozalash',
    refresh_config: 'Ilova sozlamalarini yangilash',
    refresh_entitlements: 'Huquqlarni qayta tekshirish',
    logout: 'Ilovadan chiqarish (Logout)',
    invalidate_session: 'Sessiyani darhol bekor qilish',
    diagnostics: 'O\'z-o\'zini tekshirishni ishga tushirish',
  },
};
